// extracted by mini-css-extract-plugin
module.exports = {"PdfViewer_content":"PdfViewer_PdfViewer_content__2yday"};